export enum Command {
  QUICK_SCAN = 'quick-scan',
  FULL_SCAN = 'full-scan',
  UPDATE_DEFINITIONS = 'update-definitions',
  ENABLE_RTP = 'enable-rtp',
}
